import { injectBaseConstantMethods } from "./BaseConstants";

const ADVERTISEMENT_STATUS = {
  RUNNING: "Running",
  CANCELED: "Completed",
  ACTIVE: "Active",
  INACTIVE: "InActive"
};

export default injectBaseConstantMethods(ADVERTISEMENT_STATUS);